<template>
<div class="table-grouped">
    <div class="row" v-if="canSearch">
        <amf-input label="Search" :aggressive="true" no-tracking v-model="search"></amf-input>
        <amf-button :onClick="clearSearch" style="margin-top: 24px;">Clear</amf-button>
    </div>
    <div class="row" v-if="!groupColumn || (search && search.length)">
        <div class="col-12">
            <internal-table :headerList="headerList" :itemList="extendedItemList" :rowCallback="rowCallback"></internal-table>
        </div>
    </div>
    <div class="row" v-else>
        <div class="col-12">
            <table class="table grouped" style="border-top-width: 5px;">
                <tbody v-for="(group, index) in groupList" :key="index" style="border-top-width: 1px;">
                    <tr class="group-header" :id="group.row_id" @click="function() { toggleGroup(group.row_id) }" title="Click to expand or collapse">
                        <td :colspan="columns.length">
                            <div style="text-align: center;">
                                {{group.title}}
                                <i class="fa fa-chevron-down" style="float: right;" />
                            </div>
                        </td>
                    </tr>
                    <tr class="toggle-tables" style="display: none;">
                        <td class="nested-table" :colspan="columns.length" style="padding: 0;">
                            <internal-table :headerList="headerList" :itemList="group.rows" :rowCallback="rowCallback"></internal-table>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
</template>

<script>
import Vue from "vue";
import $ from "jquery";

export default {
    props: {
        canSearch: { type: Boolean, default: true },
        headers: { type: Array, required: false },
        items: { type: Array, required: true },
        columns: { type: Array, required: false },
        groupColumn: { type: String, required: false },
        sortColumn: { type: String, required: false },
        rowCallback: { type: Function, required: false },
    },
    data() {
        return {
            _items: this.items,
            search: null,
        }
    },
    computed: {
        headerList() {
            return this.headers && this.headers.length ? this.headers : this.columnList;
        },
        columnList() {
            return this.columns && this.columns.length ? this.columns : Object.keys(this.items[0]);
        },
        filteredItems() {
            if(!this.search) return this.items;
            let lowerSearch = this.search.toLowerCase();
            return this.items.filter(item => this.columnList.find(column => (item[column] || "").toLowerCase().includes(lowerSearch)));
        },
        sortName() {
            return this.groupColumn || this.sortColumn ;
        },
        sortedItems() {
            return this.filteredItems.sort(alpha.bind({ key: this.sortName }));
        },
        extendedItemList() {
            return this.sortedItems.map(item => {
                return { ...item, row: {...this.columnList.map(column => item[column])} };
            });
        },
        groupList() {
            let groupName = "";
            let group = null;
            let groupList = [];
            
            this.extendedItemList.forEach(item => {
                if(item[this.groupColumn] != groupName) {
                    groupName = item[this.groupColumn];
                    let length = groupList.push({ row_id: `group_${groupName.replace(/[^A-Z0-9]/ig, "_")}`, title: groupName, rows: [] });
                    group = groupList[length - 1];
                }
                group.rows.push(item);
            });
            return groupList;
        },
    },
    methods: {
        toggleGroup(elem) {
            console.log("tableGrouped toggleGroup elem: ", elem);
            let head = $(`#${elem}`);
            let chevron = $(`#${elem} td i`);
            let isClosed = chevron.hasClass('fa-chevron-down');

            if(isClosed) {
                this.hideAllGroups();
                chevron.addClass('fa-chevron-up').removeClass('fa-chevron-down');
                head.next().show();
            } else {
                chevron.addClass('fa-chevron-down').removeClass('fa-chevron-up');
                head.next().hide();
            }
        },
        hideAllGroups() {
            $(`.group-header td i`).addClass('fa-chevron-down').removeClass('fa-chevron-up');
            $(`.toggle-tables`).hide();
        },
        clearSearch() {
            this.search = null;
        },
    },
}
function print(list, caller) {
    console.log(`TableGroup print ${caller}: `, list);
    return list;
}
function alpha(a, b) {
    if(a[this.key] > b[this.key]) return -1;
    else if(a[this.key] < b[this.key]) return 1;
    else 0;
}

Vue.component('internal-table', {
    template: 
        `<table class="table" style="margin-bottom: 0; background-color: inherit;">
            <thead v-if="headerList && headerList.length">
                <tr>
                    <th v-for="header in headerList" :key="header" scope="col">
                        {{header}}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in itemList" :key="index">
                    <td v-for="(prop, index) in item.row" :key="index">
                        <a v-if="rowCallback" @click.prevent="function(){ rowCallback(item)}" style="cursor: pointer;">
                            {{prop}}
                        </a>
                        <span v-else>{{prop}}</span>
                    </td>
                </tr>
            </tbody>
        </table>`,
    props: ["headerList", "itemList", "rowCallback"],
});
</script>

<style lang="scss" scoped>
// .nested-table {
//     background-color: rgb(248, 248, 248) !important;
// }
.table-grouped td a, .table-grouped .grouped tr:first-child {
    cursor: pointer;
}
.toggle-tables {
    background-color: rgb(248, 248, 248);
}
</style>


// WEBPACK FOOTER //
// src/framework/primitives/AmfTable.vue